module.exports = __webpack_public_path__ + "static/media/MAKENZY – IDEAL PROCESS_1.9672e0d0.gif";